import { render, staticRenderFns } from "./imageShow.vue?vue&type=template&id=5c37f2bd&scoped=true"
import script from "./imageShow.vue?vue&type=script&lang=js"
export * from "./imageShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c37f2bd",
  null
  
)

export default component.exports